import React from 'react'
import classNames from 'classnames'

export class HeaderBlock extends React.Component {
    constructor(props) {
        super(props)
    }	

    render() {
        return (
            <div className="header-block">
                <h1>{ this.props.header }</h1>
                <p>{ this.props.body }</p>
            </div>
        )
    }
}
